<template id="update-list">
  <div class="rounded-lg shadow p-4 h-full" ref="gurudwaraUpdateList">
    <div class="flex justify-between items-center mb-4 py-2 border-b">
      <h2 class="text-xl font-semibold">Recent Updates</h2>

      <!-- Pagination -->
      <div class="flex flex-col sm:flex-row justify-between items-center gap-4">
        <vs-pagination v-if="updateTotal > length" v-model="page" :total="totalPages" :max="7"></vs-pagination>
      </div>

      <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
        <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
          <span class="mr-2">
            {{ page * length - (length - (updateFilteredCount && 1)) || 0 }}
            -
            {{ updateFilteredCount - page * length > 0 ? page * length : updateFilteredCount }}
            of {{ updateTotal || 0 }}
          </span>
          <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
        </div>
        <vs-dropdown-menu>
          <vs-dropdown-item @click="handleChangeLength(10)">
            <span>10</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="handleChangeLength(20)">
            <span>20</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="handleChangeLength(50)">
            <span>50</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="handleChangeLength(100)">
            <span>100</span>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <!-- Tabs -->
    <div class="flex space-x-2 my-4">
      <vs-button type="border" :color="activeTab === 'all' ? 'primary' : 'dark'" @click="changeTab('all')"> All Updates </vs-button>

      <vs-button type="border" :color="activeTab === 'pinned' ? 'primary' : 'dark'" @click="changeTab('pinned')"> Pinned Updates </vs-button>
    </div>

    <!-- Loading State -->
    <!-- <div v-if="updateListLoading" class="text-center py-8">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div> -->

    <!-- Empty State -->
    <div v-if="!updateRecords.length" class="text-center py-8">
      <p>No updates found</p>
    </div>

    <!-- <div v-if="updateListLoading" class="text-center py-8">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div> -->

    <!-- Update List -->
    <div v-else id="update-list" class="vs-con-loading__container space-y-6">
      <div v-for="update in updateRecords" :key="update._id" class="border-solid overflow-hidden" style="border-radius: 20px;">
        <!-- Main Card Content -->
        <div class="p-5 flex flex-col gap-4">
          <!-- Media Gallery -->
          <div v-if="update.update_media.length">
            <div class="flex flex-wrap gap-4 justify-center">
              <div v-for="(media, index) in update.update_media" :key="media._id" class="w-full sm:w-72 md:w-96 rounded-xl overflow-hidden">
                <img v-if="media.media_type.includes('image')" :src="media.s3_url" class="h-60 w-full object-cover rounded-xl border border-gray-200" style="border-radius: 20px;overflow: hidden;" />
                <video v-else :src="media.s3_url" class="h-60 w-full object-cover rounded-xl border border-gray-200" style="border-radius: 20px;overflow: hidden;" controls></video>
              </div>
            </div>
          </div>

          <!-- Message Text -->
          <p class="text-lg text-gray-800 leading-relaxed whitespace-pre-line break-words" v-html="parseMessage(update.update_message)"></p>

          <!-- Post Date -->
          <div class="flex justify-end">
            <span class="text-sm" style="color: #666;"> Posted {{ formatDate(update.createdAt) }} </span>
          </div>
        </div>

        <!-- Action Buttons Footer -->
        <div class="flex flex-wrap gap-2 justify-end p-4 border-t border-black">
          <vs-button type="border" size="lg" icon="edit" color="black" class="hover:text-white rounded-full" @click="toggleEditModal(update._id)"> Edit </vs-button>

          <vs-button type="border" size="lg" icon="delete" color="black" class="hover:text-white rounded-full" @click="deleteRecord(update._id)"> Delete </vs-button>

          <vs-button style="border: 1px solid #000; color: #000"
          :disabled="createLoading"
          :loading="createLoading"
          id="action-button"
          :type="update.is_pinned ? 'filled' : 'border'"
          :color="update.is_pinned ? 'black' : 'none'"
          size="lg"
          :icon="update.is_pinned ? 'bookmark' : 'bookmark_border'"
          :class="[
            'vs-con-loading__container rounded-full',
            update.is_pinned
              ? 'bg-black text-white'
              : 'border border-black text-black hover:bg-black hover:text-white'
          ]"
          @click="togglePin(update)"
        >
          <span v-if="update.is_pinned" class="pinned-text">Pinned</span>
          <span v-else class="pin-text">Pin</span>

          <template #animate>
            <i v-if="update.is_pinned" class="material-icons pin-badge">done</i>
          </template>
        </vs-button>


          <vs-button type="border" size="lg" icon="content_copy" color="black" class="hover:text-white rounded-full" @click="copyUpdate(update.update_message)"> Copy </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import actionModal from './action'
export default {
  name: 'Update-list',

  components: { actionModal },
  /** Data */
  data: () => ({
    selectedRows: [],
    order: [],
    length: 100,
    page: 1,
    search: '',
    activeTab: 'all',
    form: {
      title: '',
      type: 'Details'
    },
    module_name: 'Update Us',

    // Add modal
    isAddModalMounted: false,
    isAddModalShow: false,

    // Edit modal
    isEditModalMounted: false,
    isEditModalShow: false,
    selectedRecordId: null
  }),

  /** computed */
  computed: {
    ...mapState('organization', ['updateRecords', 'updateTotal', 'updateFilteredCount', 'updateListLoading', 'createLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    validateForm() {
      return !this.errors.any()
    },
    totalPages() {
      return Math.ceil(this.updateFilteredCount / this.length)
    }
  },

  /** Functions */
  methods: {
    // Add this new method
    changeTab(tab) {
      this.activeTab = tab
      this.page = 1 // Reset to first page when changing tabs
      this.getData()
    },
    copyUpdate(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'Update copied to clipboard',
            color: 'success',
            position: 'top-center'
          })
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Error',
            text: 'Failed to copy text',
            color: 'danger',
            position: 'top-center'
          })
        })
    },

    parseMessage(message) {
      if (!message) return ''

      // Basic URL regex
      const urlRegex = /(https?:\/\/[^\s]+)/g

      // Escape HTML tags
      const escapeHTML = (str) => {
        return str.replace(/</g, '&lt;').replace(/>/g, '&gt;')
      }

      const safeText = escapeHTML(message)

      // Replace URLs with <a> tags and \n with <br>
      return safeText
        .replace(urlRegex, (url) => {
          return `<a href="${url}" target="_blank" class="text-blue-500 underline">${url}</a>`
        })
        .replace(/\n/g, '<br>')
    },

    formatDate(dateString) {
      const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }
      return new Date(dateString).toLocaleDateString(undefined, options)
    },
    ...mapActions('organization', {
      get: 'updateGet',
      delete: 'updateDelete',
      createOrUpdate: 'updateCreateOrUpdate'
    }),

    /** Toggle Select All */
    toggleSelectAll() {
      if (this.selectedRows.length === this.updateRecords.length) {
        this.selectedRows = []
      } else {
        this.selectedRows = this.updateRecords.map((tr) => tr._id)
      }
    },

    /** Toggle Individual Row Selection */
    toggleRowSelection(id) {
      const index = this.selectedRows.indexOf(id)
      if (index === -1) {
        this.selectedRows.push(id)
      } else {
        this.selectedRows.splice(index, 1)
      }
    },

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** Gurudwara List API */
    async getData() {
      try {
        const params = {
          limit: this.length,
          page: this.page,
          organizationId: this.$route.params.id
        }

        // Add is_pinned filter if on pinned tab
        if (this.activeTab === 'pinned') {
          params.is_pinned = true
        }

        await this.get(params)
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.message || 'Failed to load updates',
          color: 'danger',
          position: 'top-center'
        })
      }
    },

    // Add togglePin method
    async togglePin(update) {
      try {
        const {
          data: { message }
        } = await this.$store.dispatch('organization/togglePinUpdate', update._id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })

        this.getData()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.message || 'Failed to toggle pin status',
          color: 'danger',
          position: 'top-center'
        })
      }
    },

    toggleEditModal(id) {
      this.$emit('edit-update', id)
    },

    /** Delete Confirmation*/
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this record?`,
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },

    /** Delete  API */
    async deleteSingleRecord(id) {
      try {
        const { message } = await this.delete(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    },

    /** create Update Heading */
    async createUpdateHeading() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        this.form.organization = this.$route.params.id
        const { message } = await this.create(this.form)
        this.getData()
        this.form = {}
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    }
  },

  /** Watchers */
  watch: {
    updateListLoading() {
      if (this.updateListLoading) {
        this.$vs.loading({
          container: '#update-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#update-list > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    },
    isAddModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isAddModalMounted = false
          }, 0)
        }
      }
    },

    createLoading: {
      handler(newVal) {
        if (newVal) {
          this.$vs.loading({
            container: '#action-button',
            scale: 0.45
          })
        } else {
          this.$vs.loading.close('#action-button > .con-vs-loading')
        }
      },
      immediate: true
    },

    // Edit modal
    isEditModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isEditModalMounted = false
          }, 0)
        }
      }
    }
  },

  /** On Rendering */
  mounted() {
    this.getData()
  }
}
</script>
